import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar/Navbar';
import Footer from './components/Footer/Footer';
import Popup from './components/PopUp/PopUp'; // Add this import
import HomePage from './components/Home/HomePage';
import AboutUs from './components/AboutUs/AboutUs';
import KycPolicy from './components/KycPolicy/KycPolicy';
import Disclosure from './components/Disclosure/Disclosure';
import CompliancePage from './components/Compliance/Compliance';
import CookiePolicy from './components/CookiePolicy/CookiePolicy';
import TermsOfService from './components/TermsAndService/TermsOfService';
import PrivacyPolicy from './components/PrivacyPolicy/PrivacyPolicy';
import ContactUs from './components/Contact/Contact';
import Legal from './components/Legal/Legal';
import Security from './components/Security/Security';
import Gdpr from './components/GDPR/Gdpr';
import License from './components/License/License';
import Research from './components/Research/Research';
import HelpCenter from './components/HelpCenter/HelpCenter';
import Blog from './components/Blog/Blog';
import Press from './components/Press/Press';
import Partners from './components/Partners/Partners';
import Tutorials from './components/Tutorials/Tutorials';
import APIDocs from './components/APIDocs/APIDocs';
import Developers from './components/Developers/Developers';
import Community from './components/Community/Community';
import FAQ from './components/FAQ/FAQ';
import Careers from './components/Careers/Careers';
import './styles/Global.css';

function Layout({ children }) {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    if (location.pathname !== '/') {
      
      window.location.href = `/#${sectionId}`;
      return;
    }
    
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80; 
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
      setMobileMenuOpen(false);
    }
  };

  const navItems = [
    { label: 'Features', id: 'features' },
    { label: 'Community Pods', id: 'community-pods' },
    { label: 'Social Credit', id: 'social-credit' },
    { label: 'P2P Lending', id: 'p2p-lending' },
    { label: 'Services', id: 'services' },
  ];

  return (
    <div className="app-layout" style={{ 
      display: 'flex', 
      flexDirection: 'column', 
      minHeight: '100vh' 
    }}>
      {/* Add Popup here - it will show on ALL pages */}
      <Popup />
      
      <Navbar 
        scrolled={scrolled}
        mobileMenuOpen={mobileMenuOpen}
        setMobileMenuOpen={setMobileMenuOpen}
        scrollToSection={scrollToSection}
        navItems={navItems}
      />
      <main className="main-content" style={{ 
        flex: '1 0 auto', 
        width: '100%'      
      }}>
        {children}
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={
          <Layout>
            <HomePage />
          </Layout>
        } />
        <Route path="/about-us" element={
          <Layout>
            <AboutUs />
          </Layout>
        } />
        <Route path="/kyc-policy" element={
          <Layout>
            <KycPolicy />
          </Layout>
        } />
        <Route path="/disclosure" element={
          <Layout>
            <Disclosure />
          </Layout>
        } />
        <Route path="/compliance" element={
          <Layout>
            <CompliancePage />
          </Layout>
        } />
        <Route path="/cookie-policy" element={
          <Layout>
            <CookiePolicy />
          </Layout>
        } />
        <Route path="/terms-and-services" element={
          <Layout>
            <TermsOfService />
          </Layout>
        } />
        <Route path="/privacy-policy" element={
          <Layout>
            <PrivacyPolicy />
          </Layout>
        } />
        <Route path="/legal" element={
          <Layout>
            <Legal />
          </Layout>
        } />
        <Route path="/security" element={
          <Layout>
            <Security />
          </Layout>
        } />
        <Route path="/contact-us" element={
          <Layout>
            <ContactUs />
          </Layout>
        } />
        <Route path="/gdpr" element={
          <Layout>
            <Gdpr />
          </Layout>
        } />
        <Route path="/license" element={
          <Layout>
            <License/>
          </Layout>
        } />
        <Route path="/research" element={
          <Layout>
            <Research/>
          </Layout>
        } />
        <Route path="/help-center" element={
          <Layout>
            <HelpCenter/>
          </Layout>
        } />
        <Route path="/blog" element={
          <Layout>
            <Blog/>
          </Layout>
        } />
        <Route path="/press" element={
          <Layout>
            <Press/>
          </Layout>
        } />
        <Route path="/partners" element={
          <Layout>
            <Partners/>
          </Layout>
        } />
        <Route path="/tutorials" element={
          <Layout>
            <Tutorials/>
          </Layout>
        } />
        <Route path="/api-docs" element={
          <Layout>
            <APIDocs/>
          </Layout>
        } />
        <Route path="/developers" element={
          <Layout>
            <Developers/>
          </Layout>
        } />
        <Route path="/community" element={
          <Layout>
            <Community/>
          </Layout>
        } />
        <Route path="/faq" element={
          <Layout>
            <FAQ/>
          </Layout>
        } />
        <Route path="/careers" element={
          <Layout>
            <Careers/>
          </Layout>
        } />
      </Routes>
    </Router>
  );
}

export default App;